import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class NeedaFileService {
  constructor(private httpClient: HttpClient) { }

  public getNeedaFileContent(fileName: string): Observable<string> {
    return this.httpClient.get("/api/needa-file/" + fileName, { responseType: "text" });
  }
}